// GET https://api.swiftaid.co.uk/donor/v1-dev/me/statements
// Totals align with donations.ts per tax year (counts vary; 2025-26 has 20 donations).

const bobDonor = {
  firstname: 'Bob',
  lastname: 'Fossil',
  addressLine1: '12 Elm Close',
  addressLine2: '',
  city: 'London',
  postcode: 'SW4 8NR',
  county: '',
  country: 'United Kingdom',
}

const statementRows = [
  {
    id: 'stm_JmavJ3HB69',
    totalDonated: 508000,
    totalGiftAid: 127000,
    period: '2025-2026',
    issued: '2026-04-10T09:00:00.000Z',
    donor: bobDonor,
  },
  {
    id: 'stm_K8pQx2nR4m',
    totalDonated: 401000,
    totalGiftAid: 100250,
    period: '2024-2025',
    issued: '2025-04-10T09:00:00.000Z',
    donor: bobDonor,
  },
  {
    id: 'stm_W3tYc7vL0s',
    totalDonated: 371000,
    totalGiftAid: 92750,
    period: '2023-2024',
    issued: '2024-04-12T09:00:00.000Z',
    donor: bobDonor,
  },
  {
    id: 'stm_N6hFd1bP9z',
    totalDonated: 558000,
    totalGiftAid: 139500,
    period: '2022-2023',
    issued: '2023-04-11T09:00:00.000Z',
    donor: bobDonor,
  },
  {
    id: 'stm_R4aUe5cG2x',
    totalDonated: 373000,
    totalGiftAid: 93250,
    period: '2021-2022',
    issued: '2022-04-14T09:00:00.000Z',
    donor: bobDonor,
  },
  {
    id: 'stm_T9mIk8oH1q',
    totalDonated: 443500,
    totalGiftAid: 110875,
    period: '2019-2020',
    issued: '2020-04-14T09:00:00.000Z',
    donor: bobDonor,
  },
]

export default {
  statements: statementRows,
}
